/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// Caminho antigo da aba no legado (`router.tsx:1491-1510`): o link salvo cai no detalhe com `?tab=` (S29).
export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/historico')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/gestao-carteira/conciliacao/dataprev/$conciliationId', params, search: { tab: 'historico' }, replace: true });
  },
});
